import { render, staticRenderFns } from "./proper-lifting-technique.vue?vue&type=template&id=286a766a&"
import script from "./proper-lifting-technique.vue?vue&type=script&lang=js&"
export * from "./proper-lifting-technique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports